import React, { useEffect, useState } from 'react';
import { Table, Form, Row, Col, Modal, InputGroup } from 'react-bootstrap';
import { deleteBd, getTableBd, insertTableBd, updateTableBd } from '../../config/functions';
import { toast } from 'react-toastify';

export const DOReportDetalle = ({
    idrde,
    fecha,
    rig,
    verificado,
    reporteActividades,
    setReporteActividades,
    mobile
}) => {

    const user = JSON.parse(localStorage.getItem("token")).userName;
    const [horasTotales, setHorasTotales] = useState(0);

    const [desde, setDesde] = useState('00:00');
    const [hasta, setHasta] = useState('00:30');
    const [totalAct, setTotalAct] = useState(0);
    const [operacion, setOperacion] = useState('');
    const [actividad, setActividad] = useState('');
    const [observacion, setObservacion] = useState('');

    const [nuevaOperacion, setNuevaOperacion] = useState(false);
    const [nuevaActividad, setNuevaActividad] = useState(false);

    const [idEditar, setIdEditar] = useState(0);
    const [operacionEditar, setOperacionEditar] = useState('');
    const [actividadEditar, setActividadEditar] = useState('');
    const [observacionEditar, setObservacionEditar] = useState('');
    const [desdeEditar, setDesdeEditar] = useState('');
    const [hastaEditar, setHastaEditar] = useState('');
    const [horasEditar, setHorasEditar] = useState(0);
    const [registroEditar, setRegistroEditar] = useState({});

    const [refresh, setRefresh] = useState(false);

    const [hastas, setHastas] = useState([
        '00:30', '01:00', '01:30', '02:00', '02:30',
        '03:00', '03:30', '04:00', '04:30', '05:00', '05:30',
        '06:00', '06:30', '07:00', '07:30', '08:00', '08:30',
        '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
        '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
        '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
        '18:00', '18:30', '19:00', '19:30', '20:00', '20:30',
        '21:00', '21:30', '22:00', '22:30', '23:00', '23:30',
        '24:00'
    ]);

    const [operaciones, setOperaciones] = useState([]);
    const [actividades, setActividades] = useState([]);

    const [showModal, setShowModal] = useState(false);

    const [existeRegistro24, setExisteRegistro24] = useState(false);

    //-------------------------------------------------------

    const calcularHoras = () => {
        const hastaNormalized = (hasta === '00:00' ? '24:00' : hasta)
        const [desdeHour, desdeMinutes] = desde.split(':').map(Number);
        const [hastaHour, hastaMinutes] = hastaNormalized.split(':').map(Number);
        const desdeTimeInMinutes = desdeHour * 60 + desdeMinutes;
        const hastaTimeInMinutes = hastaHour * 60 + hastaMinutes;

        const totalTimeInMinutes = hastaTimeInMinutes - desdeTimeInMinutes;
        setTotalAct(totalTimeInMinutes > 0 ? totalTimeInMinutes / 60 : 0);
    };

    const calcularHorasTotales = () => {
        let totalHoras = 0;
        reporteActividades.forEach(op => {
            const [desdeHour, desdeMinutes] = op.desde.split(':').map(Number);
            const [hastaHour, hastaMinutes] = op.hasta.split(':').map(Number);
            const desdeTimeInMinutes = desdeHour * 60 + desdeMinutes;
            const hastaTimeInMinutes = hastaHour * 60 + hastaMinutes;
            const totalTimeInMinutes = hastaTimeInMinutes - desdeTimeInMinutes;
            totalHoras += totalTimeInMinutes > 0 ? totalTimeInMinutes / 60 : 0;
        });
        setHorasTotales(totalHoras);
    }
    //------------------------------------------------------

    useEffect(() => {
        if (reporteActividades.length > 0) {
            let totalHoras = 0;
            reporteActividades.forEach(op => {
                totalHoras += op.total;
            });
            setHorasTotales(totalHoras);

            const desdeTemp = reporteActividades[reporteActividades.length - 1].hasta;
            setDesde(desdeTemp);

            const hastaTemp = new Date(`1970-01-01T${desdeTemp}:00`);
            hastaTemp.setMinutes(hastaTemp.getMinutes() + 30);
            const formattedHasta = hastaTemp.toTimeString().slice(0, 5);
            setHasta(formattedHasta);

            const hastaFinal = new Date(`1970-01-01T24:00:00`);
            const horasPosibles = [];
            while (hastaTemp <= hastaFinal) {
                const horasString = hastaTemp.toTimeString().slice(0, 5);
                horasPosibles.push(horasString);
                hastaTemp.setMinutes(hastaTemp.getMinutes() + 30); // Incrementar en 30 minutos
            }

            setHastas(horasPosibles);
            calcularHoras(); // Recalcular horas basado en desde/hasta actuales
            calcularHorasTotales();

            const registroCompleto = reporteActividades.some(
                r => r.desde === '00:00' && (r.hasta === '24:00' || r.hasta === '00:00')
            );
            setExisteRegistro24(registroCompleto);

        } else {
            setHorasTotales(0);
            setDesde('00:00');
            setHasta('00:30'); // Asegurar que `hasta` sea 30 minutos después de `desde`
            // totalAct se calculará automáticamente por el useEffect de desde/hasta
        }
    }, [reporteActividades]);

    useEffect(() => {
        if (desde && hasta) calcularHoras();
        //console.log('desde: ', desde, 'hasta: ', hasta);
    }, [desde, hasta]);

    useEffect(() => { if (idrde) getDatos() }, [idrde, fecha, rig]);

    useEffect(() => { getDatos() }, [refresh]);

    //------------------------------------------------------

    const getOperacionesRig = async () => {
        const data = await getTableBd('getOperacionesRig/' + rig);
        if (data && data.length >= 1) {
            setOperaciones(data);
            setNuevaOperacion(false);
        }
        else {
            setOperaciones([])
            setNuevaOperacion(true)
        }
    }

    const getActividadesRig = async () => {
        const data = await getTableBd('getActividadesRig/' + rig);
        if (data && data.length >= 1) {
            setActividades(data);
            setNuevaActividad(false);
        }
        else {
            setActividades([])
            setNuevaActividad(true)
        };
    }

    const getDatos = async () => {
        const data = await getTableBd('getReporteDiarioDDRigFecha/' + rig + '/' + fecha);
        if (data && data.length >= 1) setReporteActividades(data);
        else setReporteActividades([]);

        await getOperacionesRig();
        await getActividadesRig();
    };

    const guardarDetalle = async () => {
        if (operacion !== '' && actividad !== '') {
            const dataToSend = {
                id_rde: idrde,
                desde,
                hasta,
                total: totalAct,
                operacion: operacion.toLocaleUpperCase(),
                actividad: actividad.toLocaleUpperCase(),
                observacion,
                usuario: user
            };
            //console.log('dataToSend', dataToSend);
            try {
                const response = await insertTableBd('createregistrediarioDD', dataToSend);
                if (response) {
                    setRefresh((prev) => !prev);
                    toast.success('Datos guardados correctamente.');

                    setDesde(dataToSend.hasta);
                    const newHasta = new Date(`1970-01-01T${dataToSend.hasta}:00`);
                    newHasta.setMinutes(newHasta.getMinutes() + 30);
                    const formattedHasta = newHasta.toTimeString().slice(0, 5);
                    setHasta(formattedHasta);

                    setOperacion('');
                    setActividad('');
                    setObservacion('');
                }
            } catch (error) {
                console.error('Error al guardar los datos:', error);
            }
        } else {
            toast.warning('Por favor, complete todos los campos.');
        }
    }

    //------------------------------------------------------

    const opciones = (op) => {
        setIdEditar(op.id);
        setOperacionEditar(op.operacion);
        setActividadEditar(op.actividad);
        setObservacionEditar(op.observacion);
        setDesdeEditar(op.desde);
        setHastaEditar(op.hasta);
        setHorasEditar(op.total);
        setRegistroEditar(op);

        setShowModal(true);
    }

    const guardarEditarRegistro = async () => {

        if (operacionEditar === '' && actividadEditar === '') {
            toast.warning('Por favor, complete todos los campos.');
            return;
        }

        const dataSend = {
            id: parseInt(idEditar),
            id_rde: parseInt(idrde),
            desde: desdeEditar,
            hasta: hastaEditar,
            total: horasEditar,
            operacion: operacionEditar.toLocaleUpperCase(),
            actividad: actividadEditar.toLocaleUpperCase(),
            observacion: observacionEditar,
            usuario: user
        }
        const response = await updateTableBd('updateregistrediarioDD', dataSend)
        if (response) {
            setRefresh((prev) => !prev)
            toast.success('editado exitosamente')
            setShowModal(false)
        } else {
            toast.error('Error al editar el registro.');
        }
    }

    const eliminarRegistro = async () => {
        if (window.confirm('Esta seguro de continuar?')) {
            try {
                await deleteBd(idEditar, 'deleteregisterdiarioDD')
                toast.success('Se eliminó correctamente el registro.');
                setRefresh((prev) => !prev);
                setShowModal(false)
            } catch (error) {
                console.error(error);
            }
        }
    }

    //---------------------------------------------------

    return (
        <>
            {mobile
                ? <div>
                    {reporteActividades.map((op, index) => (
                        <div
                            key={index}
                            //className="mb-1"
                            style={{
                                background: "#f8f9fa",
                                fontSize: "12px",
                                lineHeight: "1.1"
                            }}
                            onDoubleClick={() => {
                                if (verificado) return;
                                opciones(op);
                            }}
                        >
                            <Table size="sm"
                                className="mb-1"
                                bordered
                                style={{ fontSize: "11px" }}>
                                <tbody>
                                    <tr>
                                        <th className="text-center"
                                            style={{ width: "80px" }}>
                                            <span>{op.total}h</span>
                                        </th>
                                        <th className="text-center">
                                            <span>{op.desde}</span>
                                            <i className="fa-solid fa-arrow-right mx-1" />
                                            <span>{op.hasta}</span>
                                        </th>
                                    </tr>
                                    <tr className='text-start'>
                                        <td><b>Operación</b></td>
                                        <td>{op.operacion}</td>
                                    </tr>
                                    <tr className='text-start'>
                                        <td><b>Actividad</b></td>
                                        <td>{op.actividad}</td>
                                    </tr>
                                    {op.observacion && (
                                        <tr className='text-start'>
                                            <td><b>Obs.</b></td>
                                            <td>{op.observacion}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    ))}
                    {((reporteActividades.length > 0 && desde !== '00:00') || reporteActividades.length === 0) && !verificado && (
                        <Table
                            size="sm"
                            bordered
                            className="mb-2 align-middle"
                            style={{ fontSize: "12px", background: "#e9ecef" }}>
                            <tbody>
                                <tr className='table-info'>
                                    <td className="text-center p-0" style={{ width: "80px" }}>
                                        <button
                                            className="btn btn-primary btn-sm fa-solid fa-floppy-disk"
                                            style={{ fontSize: "12px", padding: "2px 8px" }}
                                            onClick={() => guardarDetalle()}
                                        />
                                    </td>
                                    <td className="text-center p-0">
                                        <span>{desde}</span>
                                        <i className="fa-solid fa-arrow-right mx-1" />
                                        <Form.Select
                                            aria-label="Hora hasta"
                                            size="sm"
                                            id={'hasta'}
                                            style={{ width: "80px", fontSize: "12px", display: "inline-block" }}
                                            onChange={(e) => setHasta(e.target.value)}
                                            value={hasta}
                                        >
                                            {hastas.map((op, index) => (
                                                <option key={index} value={op}>{op}</option>
                                            ))}
                                        </Form.Select>
                                        <i className="fa-solid fa-equals mx-1" />
                                        <span>{totalAct}h</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className='p-0'><b>Operación</b></td>
                                    <td className='p-0'>
                                        {!nuevaOperacion ? (
                                            <Form.Select
                                                aria-label="Operación"
                                                size="sm"
                                                id={'operacion'}
                                                style={{ fontSize: "12px" }}
                                                onChange={(e) => {
                                                    if (e.target.value === 'Nueva Operacion') {
                                                        setNuevaOperacion(true);
                                                    } else setOperacion(e.target.value)
                                                }}
                                                value={operacion}
                                            >
                                                <option>Seleccione Operación</option>
                                                {operaciones.map((op, index) => (
                                                    <option key={index} value={op.operacion}>{op.operacion}</option>
                                                ))}
                                                <option value='Nueva Operacion'>Nueva Operacion</option>
                                            </Form.Select>
                                        ) : (
                                            <Form.Control
                                                type="text"
                                                placeholder='Nueva Operación'
                                                title='esc to cancel'
                                                id={`nuevaOperacion`}
                                                aria-label={'nuevaOperacion'}
                                                size="sm"
                                                style={{ fontSize: "12px" }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Escape') {
                                                        setNuevaOperacion(false)
                                                        setOperacion('')
                                                    }
                                                }}
                                                onChange={(e) => setOperacion(e.target.value)}
                                                value={operacion} />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='p-0'><b>Actividad</b></td>
                                    <td className='p-0'>
                                        {!nuevaActividad ? (
                                            <Form.Select
                                                aria-label="Actividad"
                                                size="sm"
                                                id={'actividad'}
                                                style={{ fontSize: "12px" }}
                                                onChange={(e) => {
                                                    if (e.target.value === 'Nueva Actividad') {
                                                        setNuevaActividad(true);
                                                    } else setActividad(e.target.value)
                                                }}
                                                value={actividad}
                                            >
                                                <option>Seleccione Actividad</option>
                                                {actividades.map((op, index) => (
                                                    <option key={index} value={op.actividad}>{op.actividad}</option>
                                                ))}
                                                <option value='Nueva Actividad'>Nueva Actividad</option>
                                            </Form.Select>
                                        ) : (
                                            <Form.Control
                                                type="text"
                                                placeholder='Nueva Actividad'
                                                title='esc to cancel'
                                                id={`nuevaActividad`}
                                                aria-label={'nuevaActividad'}
                                                size="sm"
                                                style={{ fontSize: "12px" }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Escape') {
                                                        setNuevaActividad(false)
                                                        setActividad('')
                                                    }
                                                }}
                                                onChange={(e) => setActividad(e.target.value)}
                                                value={actividad} />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td className='p-0'><b>Obs.</b></td>
                                    <td className='p-0'>
                                        <Form.Control
                                            as="textarea"
                                            id={'observacion'}
                                            aria-label="Observación"
                                            size="sm"
                                            rows={1}
                                            style={{ fontSize: "12px", resize: "none" }}
                                            onChange={(e) => setObservacion(e.target.value)}
                                            value={observacion}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    )}
                    {/* Total horas */}
                    {reporteActividades.length > 0 && (
                        <div className="mt-1 text-end" style={{ fontSize: "12px" }}>
                            <b>Total horas: </b>
                            {
                                !(reporteActividades.length > 0 && desde !== '00:00')
                                    ? 24
                                    : horasTotales + totalAct
                            }
                        </div>
                    )}
                </div>

                : <Table
                    striped bordered hover
                    size="sm"
                    style={{ fontSize: '12px' }}
                    responsive
                    className="align-middle"
                >
                    <thead>
                        <tr>
                            <th colSpan={2}>Tiempo</th>
                            <th rowSpan={2}>Total</th>
                            <th rowSpan={2}>Operación</th>
                            <th rowSpan={2}>Actividad</th>
                            <th rowSpan={2} colSpan={2}>Observación</th>
                        </tr>
                        <tr>
                            <th>desde</th>
                            <th>hasta</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reporteActividades.map((op, index) => (
                            <tr key={index}
                                title={!verificado ? 'doble click para editar' : null}
                                onDoubleClick={() => {
                                    if (verificado) return
                                    opciones(op)
                                }}>
                                <td>{op.desde}</td>
                                <td>{op.hasta}</td>
                                <td>{op.total}</td>
                                <td>{op.operacion}</td>
                                <td>{op.actividad}</td>
                                <td colSpan={2}>{op.observacion}</td>
                            </tr>
                        ))}
                        {((reporteActividades.length > 0 && desde !== '00:00' && !existeRegistro24) 
                        || reporteActividades.length === 0) && !verificado && (
                            <tr>
                                <td>{desde} </td>
                                <td>
                                    <Form.Select
                                        aria-label="Hora hasta"
                                        size="sm"
                                        id={'hasta'}
                                        onChange={(e) => setHasta(e.target.value)}
                                        value={hasta}
                                    >
                                        {hastas.map((op, index) => (
                                            /* index !== 0 && ( */
                                            <option key={index} value={op}>{op}</option>
                                            /* ) */
                                        ))}
                                    </Form.Select>
                                </td>
                                <td>{totalAct}</td>
                                <td>
                                    {!nuevaOperacion ?
                                        (
                                            <Form.Select
                                                aria-label="Operación"
                                                size="sm"
                                                id={'operacion'}
                                                onChange={(e) => {
                                                    if (e.target.value === 'Nueva Operacion') {
                                                        setNuevaOperacion(true);
                                                    } else setOperacion(e.target.value)
                                                }}
                                                value={operacion}
                                            >
                                                <option>Seleccione Operación</option>
                                                {operaciones.map((op, index) => (
                                                    <option key={index} value={op.operacion}>{op.operacion}</option>
                                                ))}
                                                <option value='Nueva Operacion'>Nueva Operacion</option>
                                            </Form.Select>
                                        )
                                        : (
                                            <Form.Control
                                                type="text"
                                                placeholder='Nueva Operación'
                                                title='esc to cancel'
                                                id={`nuevaOperacion`}
                                                aria-label={'nuevaOperacion'}
                                                size="sm"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Escape') {
                                                        setNuevaOperacion(false)
                                                        setOperacion('')
                                                    }
                                                }}
                                                onChange={(e) => setOperacion(e.target.value)}
                                                value={operacion} />
                                        )
                                    }
                                </td>
                                <td>
                                    {!nuevaActividad ?
                                        (
                                            <Form.Select
                                                aria-label="Actividad"
                                                size="sm"
                                                id={'actividad'}
                                                onChange={(e) => {
                                                    if (e.target.value === 'Nueva Actividad') {
                                                        setNuevaActividad(true);
                                                    } else setActividad(e.target.value)
                                                }}
                                                value={actividad}
                                            >
                                                <option>Seleccione Actividad</option>
                                                {actividades.map((op, index) => (
                                                    <option key={index} value={op.actividad}>{op.actividad}</option>
                                                ))}
                                                <option value='Nueva Actividad'>Nueva Actividad</option>
                                            </Form.Select>
                                        )
                                        : (
                                            <Form.Control
                                                type="text"
                                                placeholder='Nueva Actividad'
                                                title='esc to cancel'
                                                id={`nuevaActividad`}
                                                aria-label={'nuevaActividad'}
                                                size="sm"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Escape') {
                                                        setNuevaActividad(false)
                                                        setActividad('')
                                                    }
                                                }}
                                                onChange={(e) => setActividad(e.target.value)}
                                                value={actividad} />
                                        )
                                    }
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        id={'observacion'}
                                        aria-label="Observación"
                                        size="sm"
                                        onChange={(e) => setObservacion(e.target.value)}
                                        value={observacion}
                                    />
                                </td>
                                <td>
                                    <button
                                        className="btn fa-solid fa-floppy-disk"
                                        onClick={() => guardarDetalle()}
                                    />
                                </td>
                            </tr>
                        )}
                    </tbody>
                    {reporteActividades.length > 0 && (
                        <tfoot>
                            <tr>
                                <td colSpan={2}>Total</td>
                                <td>
                                    {
                                        !((reporteActividades.length > 0 && desde !== '00:00'))
                                            ? 24
                                            : existeRegistro24 ? 24 :horasTotales + totalAct
                                    }
                                </td>
                                <td colSpan={4}></td>
                            </tr>
                        </tfoot>
                    )}
                </Table>
            }
            {showModal &&
                (
                    <Modal show={showModal} onHide={() => setShowModal(false)} size="sm" centered>
                        <Modal.Header closeButton>
                            <Modal.Title style={{ fontSize: '18px' }}> Opciones de Edición </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>

                            <Row >
                                <Col sm={6} className="mb-2">
                                    <InputGroup className="mb-2" size="sm">
                                        <InputGroup.Text id={'desdeEditar'}>Desde</InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            id={`desdeEditar`}
                                            aria-label={'desdeEditar'}
                                            size="sm"
                                            disabled
                                            //onChange={(e) => setDesdeEditar(e.target.value)}
                                            value={desdeEditar} />
                                    </InputGroup>
                                </Col>
                                <Col sm={6} className="mb-2">
                                    <InputGroup className="mb-2" size="sm">
                                        <InputGroup.Text id={'hastaEditar'}>Hasta</InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            id={`hastaEditar`}
                                            aria-label={'hastaEditar'}
                                            size="sm"
                                            disabled
                                            //onChange={(e) => setHastaEditar(e.target.value)}
                                            value={hastaEditar} />
                                    </InputGroup>
                                </Col>
                            </Row>
                            <Row >
                                <Col sm={12} className="mb-2">
                                    <InputGroup className="mb-2" size="sm">
                                        <InputGroup.Text id={'operacionEditar'}>Operación</InputGroup.Text>
                                        <Form.Select
                                            aria-label="Operación"
                                            size="sm"
                                            id={'operacionEditar'}
                                            onChange={(e) => setOperacionEditar(e.target.value)}
                                            value={operacionEditar}
                                        >
                                            {operaciones.map((op, index) => (
                                                <option key={index} value={op.operacion}>{op.operacion}</option>
                                            ))}
                                        </Form.Select>
                                    </InputGroup>
                                </Col>
                                <Col sm={12} className="mb-2">
                                    <InputGroup className="mb-2" size="sm">
                                        <InputGroup.Text id={'actividadEditar'}>Actividad</InputGroup.Text>
                                        <Form.Select
                                            aria-label="Actividad"
                                            size="sm"
                                            id={'actividadEditar'}
                                            onChange={(e) => setActividadEditar(e.target.value)}
                                            value={actividadEditar}
                                        >
                                            {actividades.map((op, index) => (
                                                <option key={index} value={op.actividad}>{op.actividad}</option>
                                            ))}
                                        </Form.Select>
                                    </InputGroup>
                                </Col>
                                <Col sm={12} className="mb-2">
                                    <InputGroup className="mb-2" size="sm">
                                        <InputGroup.Text id={'observacionEditar'}>Observación</InputGroup.Text>
                                        <Form.Control
                                            as="textarea"
                                            id={`observacionEditar`}
                                            aria-label={'observacionEditar'}
                                            size="sm"
                                            onChange={(e) => setObservacionEditar(e.target.value)}
                                            value={observacionEditar} />
                                    </InputGroup>
                                </Col>
                            </Row>


                        </Modal.Body>

                        <Modal.Footer>
                            <button
                                className='btn btn-sm btn-secondary'
                                onClick={() => setShowModal(false)}>
                                Cerrar
                            </button>
                            <button
                                className='btn btn-primary fa-solid fa-floppy-disk'
                                title='Guardar Cambios'
                                onClick={() => guardarEditarRegistro()} />
                            {registroEditar === reporteActividades[reporteActividades.length - 1] &&
                                <button
                                    className='btn btn-danger fa-solid fa-trash-can'
                                    title='Eliminar Empleado'
                                    onClick={() => eliminarRegistro()} />
                            }


                        </Modal.Footer>
                    </Modal>
                )}
        </>
    );
};